module.exports = __webpack_public_path__ + "img/email.8d46b523.svg";